import React from "react";

// Import Styles
import "../contacts/ContactUs.scss";
import classNames from "classnames/bind";
// import styles from "../modals/privacy-policy/PrivacyPolicy.module.scss";
import styles from "./ContactUs.module.scss";

// Import Components
import MaxWidthContainer from "../../components/UI/MaxWidthContainer/MaxWidthContainer";
import { useConfig } from "../../providers/config";

import Page from "../page-layout";
import { activeModule } from "../../providers/active-module";
import { Browser } from "@capacitor/browser";

const cx = classNames.bind(styles);
const codeBaseVersion = process.env.REACT_APP_PARHATO_CODE_VERSION!;

const ContactUs: React.FC = () => {
  const config = useConfig();

  const createMarkup = () => {
    if (config?.contactUsPage) {
      return { __html: config.contactUsPage };
    }
  };

  const handleOpenUrl = async (url: string) => {
    await Browser.open({ url });
  };

  return (
    <Page>
      <Page.HeaderMobile showBackButton showSearchButton />
      <Page.Content>
        <Page.HeaderDesktop />
        <MaxWidthContainer classList={"global-content"}>
          {!!config?.contactUsPage ? (
            <p
              className={cx("ion-no-margin ion-margin-start ion-margin-end", "contacts")}
              dangerouslySetInnerHTML={createMarkup()}
            ></p>
          ) : (
            <div className="p-4 gap-y-10 sm:p-10 m-2 border-2 border-gray-200 rounded-xl flex flex-col lg:flex-row gap-y-4">
              <div className="md:mr-20">
                <h1 className="text-3xl mb-4 font-bold">Контакты</h1>
                <div className="flex flex-col gap-y-2">
                  {config.contacts.map((contact, index) => (
                    <div key={index} className="xs:flex xs:justify-between xs:gap-x-4 max-w-[600px]">
                      <div className="text-gray-400">{contact.title}</div>
                      <div className="hover:text-irsRed" onClick={() => handleOpenUrl(contact.url)}>
                        {contact.contact}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              {!!config.requisites.length && (
                <div className="md:max-w-[50%]">
                  <h1 className="text-3xl mb-4 font-bold">Реквизиты:</h1>
                  <div className="flex flex-col gap-y-2">
                    {config.requisites.map((requisite, index) => (
                      <div key={index}>{requisite}</div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}
        </MaxWidthContainer>
        <Page.ContentFooter />
        {/* <p className={cx("appVersionLabel")}>
          {activeModule} v{codeBaseVersion}
        </p> */}
      </Page.Content>
    </Page>
  );
};

export default ContactUs;
